"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Obfuscate = void 0;
const FlagFromLog_1 = require("./FlagFromLog");
function Obfuscate() {
    return FlagFromLog_1.FlagFromLog("obfuscate");
}
exports.Obfuscate = Obfuscate;
//# sourceMappingURL=Obfuscate.js.map